// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuButton_container__2mXZ1","button":"MenuButton_button__2lNo7","selectedValue":"MenuButton_selectedValue__1ymEm","menu":"MenuButton_menu__n0Ygq"};